export class ChartBounds<C, R = any> {
    public minY = Number.MAX_SAFE_INTEGER;
    public maxY = Number.MIN_SAFE_INTEGER;
    public minX = Number.MAX_SAFE_INTEGER;
    public maxX = Number.MIN_SAFE_INTEGER;
    public data: C[] = [];
    public rawData: R[] = [];
}
